import { useEffect } from "react";
import type React from "react";
import { useDispatch } from "react-redux";
import { setPageHeader, clearPageHeader } from "../Redux/Slice/PageHeaderSlice";
import { usePageHeaderActionsDispatch } from "../Components/PageHeaderActionsProvider";

type UsePageHeaderOptions = {
	title: string;
	actions?: React.ReactNode | null;
	/** When false, the hook is inert — used when a page component is embedded (e.g. inside a modal)
	 *  and must not hijack the global page header. Defaults to true. */
	enabled?: boolean;
};

export const usePageHeader = ({ title, actions = null, enabled = true }: UsePageHeaderOptions) => {
	const dispatch = useDispatch();
	const setActions = usePageHeaderActionsDispatch();

	useEffect(() => {
		if (!enabled) return;
		dispatch(setPageHeader({ title }));
		setActions(actions);
		return () => {
			dispatch(clearPageHeader());
			setActions(null);
		};
	}, [dispatch, title, actions, setActions, enabled]);
};
